import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  fill: "currentColor",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14 2.75A1.76 1.76 0 0 0 12.25 1H1.75A1.76 1.76 0 0 0 0 2.75v6.5A1.76 1.76 0 0 0 1.75 11H5a.26.26 0 0 1 .21.11.29.29 0 0 1 0 .24L4.56 13a.75.75 0 0 0 .69 1h3.5a.75.75 0 0 0 .69-1l-.67-1.61a.29.29 0 0 1 0-.24A.26.26 0 0 1 9 11h3.25A1.76 1.76 0 0 0 14 9.25ZM4.23 6.92a.75.75 0 0 1-.48 1.33.78.78 0 0 1-.48-.17l-1.5-1.25a.76.76 0 0 1 0-1.15l1.75-1.5a.75.75 0 0 1 1 1.14l-.85.73a.25.25 0 0 0 0 .38ZM8.46 4 7 8.49a.75.75 0 0 1-.75.51A.67.67 0 0 1 6 9a.75.75 0 0 1-.47-1L7 3.51A.75.75 0 0 1 8.46 4Zm3.78 2.83-1.75 1.5a.75.75 0 1 1-1-1.14l.85-.73a.25.25 0 0 0 0-.38l-.59-.49a.75.75 0 0 1 1-1.16l1.5 1.25a.76.76 0 0 1 0 1.15Z" }, null, -1)
  ])))
}
export default { render: render }